import { render, staticRenderFns } from "./AdditionalQuestions.vue?vue&type=template&id=b4490ba4&scoped=true&"
import script from "./AdditionalQuestions.vue?vue&type=script&lang=js&"
export * from "./AdditionalQuestions.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalQuestions.vue?vue&type=style&index=0&id=b4490ba4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4490ba4",
  null
  
)

export default component.exports